export default {
	lead: {
		schoolName: '',
		contactName: '',
		contactEmailAddress: '',
		mobilePhoneNumber: '',
		studentsQuantity: 500,
		plan: '',
		levels: [],
		voucherNumber: ''
	}
};



// WEBPACK FOOTER //
// ./sources/app/simulator/simulator/state.js